export default "__VITE_ASSET__C86$IzxR__"